import Cookies from 'js-cookie'
import { AUTH_TOKEN_KEY } from '@unowmooc/utils/constants'
import config from 'config'

// 4 heures
const AUTH_COOKIE_DURATION_IN_SECONDS = 14400

const DEBOUNCE_DURATION_IN_MILLISECONDS = 1000 * 60 * 5

export const setLmsCookie = (name, value) => {
  const cookieOptions = {
    expires: AUTH_COOKIE_DURATION_IN_SECONDS / 60 / 60 / 24, // la durée est en jours
    partitioned: true,
  }

  // on a besoin du sameSite pour que le partitionned fonctionne
  cookieOptions.sameSite = 'None'
  cookieOptions.secure = true

  Cookies.set(name, value, cookieOptions)
}

let cookieCreationDate = 0

/**
 * Cette méthode reporte la durée de validation du cookie
 *
 * @param {string} token
 */
export const handleAuthCookie = (token, isFromLms) => {
  const millisecondsElapsedFromTheCookieCreation = Date.now() - cookieCreationDate

  if (millisecondsElapsedFromTheCookieCreation < DEBOUNCE_DURATION_IN_MILLISECONDS) {
    return
  }

  if (isFromLms) {
    Cookies.remove('lms-auth-token')
    setLmsCookie('lms-auth-token', token)
  } else {
    const options = {
      domain: config.env.COOKIE_DOMAIN,
      expires: AUTH_COOKIE_DURATION_IN_SECONDS / 60 / 60 / 24,
    }

    // Impossible de set une nouvelle valeur à une clée existante donc on supprime la key/value
    Cookies.remove(AUTH_TOKEN_KEY, options)
    Cookies.set(AUTH_TOKEN_KEY, token, options)
  }

  cookieCreationDate = Date.now()
}
